/* Página atualizada e funcionando

Essa parte de layouts serve para chamar o código que está em pages, onde tudo é realmente montado.

*/

import SobreNos from "pages/Empresa/SobreNos";

export default function SobreNosPage() {
  return <SobreNos />;
}
